import { render, staticRenderFns } from "./ButtonExpand.vue?vue&type=template&id=ed453e34&"
import script from "./ButtonExpand.vue?vue&type=script&lang=js&"
export * from "./ButtonExpand.vue?vue&type=script&lang=js&"
import style0 from "./ButtonExpand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports